import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['label', 'span']

  // Restore the selected styling (background + outline + text colour) for a radio
  // that arrives already checked from the server, so a reloaded answer looks the
  // same as one just clicked.
  connect() {
    const checked = this.element.querySelector('input[type="radio"]:checked')
    if (checked) this.check(checked)
  }

  toggle(e) {
    this.uncheckAll()
    this.check(e.currentTarget)
  }

  check(input) {
    const label = input.closest('label')
    const span = label.querySelector('span')
    const classes = this.getClasses()

    label.classList.add(...classes.checkedBg)
    label.classList.remove(...classes.uncheckedBg)

    span.classList.add(...classes.checkedText)
    span.classList.remove(...classes.uncheckedText)
  }

  uncheckAll() {
    const classes = this.getClasses()

    this.labelTargets.forEach(label => {
      label.classList.remove(...classes.checkedBg)
      label.classList.add(...classes.uncheckedBg)
    })

    this.spanTargets.forEach(span => {
      span.classList.remove(...classes.checkedText)
      span.classList.add(...classes.uncheckedText)
    })
  }

  getClasses() {
    const { dataset } = this.element
    
    return {
      checkedBg: dataset.radioBackgroundCheckedBgClass.split(' '),
      uncheckedBg: dataset.radioBackgroundUncheckedBgClass.split(' '),
      checkedText: dataset.radioBackgroundCheckedTextClass.split(' '),
      uncheckedText: dataset.radioBackgroundUncheckedTextClass.split(' ')
    }
  }
}